export const GO_TO_PROFILE_LABEL = 'button.label.go.to.profile';
export const NAV_BACK_BUTTON = 'button.label.nav.back';
